import React from "react";
import { Container, Stack, Typography } from "@mui/material";
import ContactForm from "./contact/ContactForm";

const Contact = () => {
  return (
    <Container maxWidth="md" sx={{ py: { xs: 6, md: 8 } }}>
      <Stack spacing={4} alignItems="center">
        <Stack spacing={1} alignItems="center">
          <Typography variant="h3" component="h1" textAlign="center">
            Contact Us
          </Typography>
          <Typography textAlign="center" color="text.secondary">
            We'd love to hear from you! Please fill out the form below and we'll
            get back to you soon.
          </Typography>
        </Stack>

        <ContactForm />
      </Stack>
    </Container>
  );
};

export default Contact;
